import { render, staticRenderFns } from "./MessageItemLinkView.vue?vue&type=template&id=3e8012d6&scoped=true&"
import script from "./MessageItemLinkView.vue?vue&type=script&lang=ts&"
export * from "./MessageItemLinkView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItemLinkView.vue?vue&type=style&index=0&id=3e8012d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8012d6",
  null
  
)

export default component.exports